"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomPaper = exports.getSearchInputStyles = exports.StyledBox = exports.CheckWrap = exports.AvatarContainer = exports.AvatarTitleWrap = exports.Title = exports.TitleContainer = void 0;
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var colors_1 = require("../ThemeProvider/colors");
var prism_icons_1 = require("@octanner/prism-icons");
var material_1 = require("@mui/material");
var CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
var Paper_1 = __importDefault(require("../Paper"));
exports.TitleContainer = (0, material_1.styled)('div')({
    alignItems: 'flex-start',
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: 8,
});
exports.Title = (0, material_1.styled)('div', { name: 'Title' })(function (_a) {
    var sub = _a.sub, light = _a.light, disabled = _a.disabled;
    return ({
        color: sub || light || disabled ? colors_1.tannerGray['600'] : '#000000',
        fontSize: sub ? 12 : 14,
        alignSelf: light ? 'center' : undefined,
    });
});
exports.AvatarTitleWrap = (0, material_1.styled)('div', { name: 'AvatarTitleWrap' })(function (_a) {
    var _b = _a.selected, selected = _b === void 0 ? false : _b;
    return ({
        display: 'flex',
        flex: '1 1 auto',
        opacity: selected ? 0.5 : 1,
    });
});
exports.AvatarContainer = (0, material_1.styled)('div', { name: 'AvatarContainer' })(function (_a) {
    var disabled = _a.disabled;
    return ({
        opacity: disabled ? 0.2 : 1,
    });
});
exports.CheckWrap = (0, material_1.styled)('div', { name: 'CheckWrap' })({
    width: 24,
    textAlign: 'right',
});
var StyledSpan = (0, material_1.styled)('span')({
    marginRight: '8px',
    marginLeft: '8px',
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
});
exports.StyledBox = (0, material_1.styled)(Box_1.default)(function (_a) {
    var theme = _a.theme, disabled = _a.disabled, rest = __rest(_a, ["theme", "disabled"]);
    return ({
        borderRadius: 3,
        display: 'flex',
        padding: 8,
        width: '100%',
        pointerEvents: disabled ? 'none' : 'auto',
    });
});
var getSearchInputStyles = function (disabled, props, loading) { return (__assign(__assign({ sx: function () {
        return disabled
            ? {
                backgroundColor: colors_1.tannerGray['100'],
                color: colors_1.tannerGray['400'],
            }
            : __assign({}, (props.size === 'small' && {
                backgroundColor: colors_1.tannerGray['50'],
            }));
    } }, props.InputProps), { startAdornment: (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledSpan, null, loading ? (react_1.default.createElement(CircularProgress_1.default, { size: "16px", "aria-label": "loading" })) : (react_1.default.createElement(prism_icons_1.Search, null))),
        props.InputProps.startAdornment)) })); };
exports.getSearchInputStyles = getSearchInputStyles;
var CustomPaper = function (_a) {
    var paperProps = __rest(_a, []);
    return (react_1.default.createElement(Paper_1.default, __assign({ sx: { mt: '4px' } }, paperProps)));
};
exports.CustomPaper = CustomPaper;
//# sourceMappingURL=styles.js.map